const WarningIcon = () => {
  return (
    <svg
      aria-hidden="true"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2090_22062)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.72346 1.5C9.33856 0.833333 8.3763 0.833334 7.9914 1.5L1.0632 13.5C0.678301 14.1667 1.15943 15 1.92923 15H15.7856C16.5554 15 17.0366 14.1667 16.6517 13.5L9.72346 1.5ZM9.85743 6C9.85743 5.44771 9.40972 5 8.85743 5C8.30515 5 7.85743 5.44771 7.85743 6V9C7.85743 9.55229 8.30515 10 8.85743 10C9.40972 10 9.85743 9.55229 9.85743 9V6ZM7.85743 12C7.85743 11.4477 8.30515 11 8.85743 11C9.40972 11 9.85743 11.4477 9.85743 12C9.85743 12.5523 9.40972 13 8.85743 13C8.30515 13 7.85743 12.5523 7.85743 12Z"
          fill="#DE7C12"
        />
      </g>
      <defs>
        <clipPath id="clip0_2090_22062">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.857422)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default WarningIcon
